export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9107.c76944ec.jpg";